import { useWorkspace } from "@commerce/components/use-workspace";
import { SettingsLayout } from "@saas/settings/components/SettingsLayout";
import { AppNotFound } from "@saas/shared/components/AppNotFound";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_saas/app/_account/settings")({
	component: AccountSettingsLayout,
	notFoundComponent: () => <AppNotFound />,
});

function AccountSettingsLayout() {
	const { role } = useWorkspace();
	return (
		<SettingsLayout
			isOrganizationAdmin={role === "owner" || role === "admin"}
		>
			<Outlet />
		</SettingsLayout>
	);
}
